export const locale = {
    lang: 'zh2',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': '网络公司简介',
        'TIT_WCP_DAT': '访问数据',
        'CHAN_INF':'加载信息',
        'HELP':'帮助',
        'EnlaceWCP':'复制链接进入公司简介',
        'ClaveWCP':'复制密码进入公司简介',
        'PORDUC_CER':{
          '40':'认证 3.0',
          '1':'证明',
          '20':'认证 2.0',
        },
        'ESTA_WEB_CP':{
          'false':'我不发布',
          'true':'公共',
        },
        'MODAL':{
          'TIT_MOD':'不发表的原因是什么？',
           'BTN_CONT':'继续',
           'BTN_CANC':'取消',
           'RAISON_OBLIG': '要继续，您必须输入未发表的原因',
           'TIT_CONDI_US':'使用条款',
           'TEX1_CONDI_US':'公司简介公开后，将与已配置的信息一起发布在 Great Place To Work(r) 页面上。Great Place to Work(r) 对内容不承担任何责任，因为发布的数据是同一家公司在为其准备的平台上上传的信息的结果。',
           'TEX2_CONDI_US':'此外，公司同意将这些信息上传到已签约的各种搜索引擎，以增加对已获得 Great Place To Work(r) 认证的最佳工作公司的传播',
           'TEX3_CONDI_US':'公司可能随时将公司简介恢复为私人模式，这将导致其不再出现在认证公司列表中，但是 Great Place To Work(r) 将无法删除 搜索引擎已完成的索引，因此公司名称可能会在一段时间内继续出现在 Great Place To Work 使用的不同搜索引擎的搜索结果中。',
           'TEX4_CONDI_US':'发布或不发布此公司简介由公司全权负责。',
           'REA_TEX_CONDI_US':'要确认，请写下以下文字',
           'NO_DISPO_ARCHI':'文件不可用',
        }

      }
    }
};
